/* tslint:disable */
/* eslint-disable */
/**
 * FOPkasa.Web
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CreateIbanQrInvoiceRequestDto } from '../models';
import { IbanQrInvoiceResponseDto } from '../models';
import { ProblemDetails } from '../models';
/**
 * IbanQrInvoiceApi - axios parameter creator
 * @export
 */
export const IbanQrInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanQrIbanInvoiceUidGet: async (ibanInvoiceUid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ibanInvoiceUid' is not null or undefined
            if (ibanInvoiceUid === null || ibanInvoiceUid === undefined) {
                throw new RequiredError('ibanInvoiceUid','Required parameter ibanInvoiceUid was null or undefined when calling apiIbanQrIbanInvoiceUidGet.');
            }
            const localVarPath = `/api/iban-qr/{ibanInvoiceUid}`
                .replace(`{${"ibanInvoiceUid"}}`, encodeURIComponent(String(ibanInvoiceUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateIbanQrInvoiceRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanQrPost: async (body?: CreateIbanQrInvoiceRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-qr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IbanQrInvoiceApi - functional programming interface
 * @export
 */
export const IbanQrInvoiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<IbanQrInvoiceResponseDto>>> {
            const localVarAxiosArgs = await IbanQrInvoiceApiAxiosParamCreator(configuration).apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {CreateIbanQrInvoiceRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanQrPost(body?: CreateIbanQrInvoiceRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<IbanQrInvoiceResponseDto>>> {
            const localVarAxiosArgs = await IbanQrInvoiceApiAxiosParamCreator(configuration).apiIbanQrPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * IbanQrInvoiceApi - factory interface
 * @export
 */
export const IbanQrInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid: string, options?: AxiosRequestConfig): Promise<AxiosResponse<IbanQrInvoiceResponseDto>> {
            return IbanQrInvoiceApiFp(configuration).apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateIbanQrInvoiceRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanQrPost(body?: CreateIbanQrInvoiceRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<IbanQrInvoiceResponseDto>> {
            return IbanQrInvoiceApiFp(configuration).apiIbanQrPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IbanQrInvoiceApi - object-oriented interface
 * @export
 * @class IbanQrInvoiceApi
 * @extends {BaseAPI}
 */
export class IbanQrInvoiceApi extends BaseAPI {
    /**
     * 
     * @param {string} ibanInvoiceUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanQrInvoiceApi
     */
    public async apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<IbanQrInvoiceResponseDto>> {
        return IbanQrInvoiceApiFp(this.configuration).apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {CreateIbanQrInvoiceRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanQrInvoiceApi
     */
    public async apiIbanQrPost(body?: CreateIbanQrInvoiceRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<IbanQrInvoiceResponseDto>> {
        return IbanQrInvoiceApiFp(this.configuration).apiIbanQrPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
